import { Divider, FormControlLabel, Grid } from '@material-ui/core';
import { FormCheckbox, Column, Columns, Flex, FormInput, Subsection } from 'lqx-react';
import * as React from 'react';
import { ProductModuleNames, RelationshipModel } from 'api/relationship';
import { CollapsableInputGroup, OptionalInput, OptionalTextField } from '../common';

export const ModulesTopSection = ({ relationship }: { relationship: RelationshipModel }) => {

    return (
        <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={3}
        >
            <Grid container item xs={12}>
                <CollapsableInputGroup
                    id="order-management"
                    headingText="Order Management"
                    actionClarificationText="Enable module"
                    $enable={relationship.$.productModules.contains(ProductModuleNames.OrderManagement)}
                >
                    <Flex center stretch>Under development</Flex>
                </CollapsableInputGroup>
            </Grid>
            <Grid container item xs={12}>
                <CollapsableInputGroup
                    id="Inmatch"
                    headingText="Inmatchd"
                    actionClarificationText="Enable module"
                    $enable={relationship.$.productModules.contains(ProductModuleNames.Inmatch)}
                >
                    <Flex center stretch>Under development</Flex>
                </CollapsableInputGroup>
            </Grid>
            <Grid container item xs={12}>
                <CollapsableInputGroup
                    id="invoice-management"
                    headingText="Invoice Management"
                    actionClarificationText="Enable module"
                    $enable={relationship.$.productModules.contains(ProductModuleNames.InvoiceManagement)}
                >
                <EditInvoiceManagementDispute
                    relationship={relationship}
                />
                </CollapsableInputGroup>
            </Grid>
            <Grid container item xs={12}>
                <CollapsableInputGroup
                    id="cashflow-forecasting"
                    headingText="Cashflow Forecasting"
                    actionClarificationText="Enable module"
                    $enable={relationship.$.productModules.contains(ProductModuleNames.CashflowForecasting)}
                >
                    <Flex center stretch>Under development</Flex>
                </CollapsableInputGroup>
            </Grid>

        </Grid>
    )
}

const EditInvoiceManagementDispute = ({ relationship }) => {
    return (
        <Subsection
            title="Invoice Attributes"
        >
            <Columns>
                <Column>
                    <FormInput positive integer
                        $value={relationship.$.customerAutoAcceptThreshold}
                        label="Auto Accept Threshold"
                    />
                    <OptionalInput
                        checkboxLabel="Email Delivery of Invoices and Notifications"
                        $value={{}}
                    >
                        <FormInput
                            // $value={{}}
                            label="Email Address"
                        />
                        <FormInput
                            // $value={{}}
                            label="Entitled Users"
                        />
                        <FormInput
                            // $value={{}}
                            label="Delivery Frequency"
                        />
                    </OptionalInput>
                    <Divider />
                    <FormControlLabel
                        control={
                            <FormCheckbox
                                defaultChecked
                                color="default"
                                inputProps={{ 'aria-label': 'checkbox with default color' }}
                            />
                        }
                        label="PDF Invoice Delivery"
                    />
                    <FormControlLabel
                        control={
                            <FormCheckbox
                                defaultChecked
                                color="default"
                                inputProps={{ 'aria-label': 'checkbox with default color' }}
                            />
                        }
                        label="In App Notifications for Invoices"
                    />
                    <Divider />
                    <OptionalTextField
                        checkboxLabel="First promise to pay chaser"
                        textFieldLabel="days before the invoice is due"
                    />
                    <OptionalTextField
                        checkboxLabel="Second promise to pay chaser"
                        textFieldLabel="days before the invoice is due"
                    />
                    <OptionalTextField
                        checkboxLabel="Reminder to pay coming due invoices"
                        textFieldLabel="days before the invoice is due"
                    />
                    <OptionalTextField
                        checkboxLabel="Remittance received but no cash received"
                        textFieldLabel="days after payment execution date"
                    />
                    <OptionalTextField
                        checkboxLabel="First reminder to add remittance"
                        textFieldLabel="days after promise to pay date"
                    />
                    <OptionalTextField
                        checkboxLabel="Second reminder to add remittance"
                        textFieldLabel="days after promise to pay date"
                    />
                    <OptionalTextField
                        checkboxLabel="Promise to pay broken notification"
                        textFieldLabel="days after promise to pay date based on promise to pay threshold"
                    />
                </Column>
                <Column>
                </Column>
            </Columns>
        </Subsection>
    );
};
